// extracted by mini-css-extract-plugin
module.exports = {"container":"domain_container__1phcm","content":"domain_content__-Qdem","headerContainer":"domain_headerContainer__3pQN2","iconQuestion":"domain_iconQuestion__1o00Q"};